 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLCH0001_FM from '@/components/xhtml/ch0001_fm'
 import XHTMLCH0002_HALFTITLE from '@/components/xhtml/ch0002_halftitle'
 import XHTMLCH0003_TITLE from '@/components/xhtml/ch0003_title'
 import XHTMLCH0004_COPYRIGHT from '@/components/xhtml/ch0004_copyright'
 import XHTMLCH0005_DEDI from '@/components/xhtml/ch0005_dedi'
 import XHTMLCH0006_TOC from '@/components/xhtml/ch0006_toc'
 import XHTMLCH0007_FOREWORD from '@/components/xhtml/ch0007_foreword'
 import XHTMLCH0008_INTRODUCTION from '@/components/xhtml/ch0008_introduction'
 import XHTMLCH0009_PART01 from '@/components/xhtml/ch0009_part01'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH05_PART02 from '@/components/xhtml/ch05_part02'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLCH09 from '@/components/xhtml/ch09'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLCH11 from '@/components/xhtml/ch11'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLACK from '@/components/xhtml/ack'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLABT from '@/components/xhtml/abt'
 import XHTMLPUB from '@/components/xhtml/pub'
 import XHTMLCONN from '@/components/xhtml/conn'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/ch0001_fm",
 			"name" : "xhtml/ch0001_fm",
 			"component" : XHTMLCH0001_FM
 		},
 		{
 			"path" : "/xhtml/ch0002_halftitle",
 			"name" : "xhtml/ch0002_halftitle",
 			"component" : XHTMLCH0002_HALFTITLE
 		},
 		{
 			"path" : "/xhtml/ch0003_title",
 			"name" : "xhtml/ch0003_title",
 			"component" : XHTMLCH0003_TITLE
 		},
 		{
 			"path" : "/xhtml/ch0004_copyright",
 			"name" : "xhtml/ch0004_copyright",
 			"component" : XHTMLCH0004_COPYRIGHT
 		},
 		{
 			"path" : "/xhtml/ch0005_dedi",
 			"name" : "xhtml/ch0005_dedi",
 			"component" : XHTMLCH0005_DEDI
 		},
 		{
 			"path" : "/xhtml/ch0006_toc",
 			"name" : "xhtml/ch0006_toc",
 			"component" : XHTMLCH0006_TOC
 		},
 		{
 			"path" : "/xhtml/ch0007_foreword",
 			"name" : "xhtml/ch0007_foreword",
 			"component" : XHTMLCH0007_FOREWORD
 		},
 		{
 			"path" : "/xhtml/ch0008_introduction",
 			"name" : "xhtml/ch0008_introduction",
 			"component" : XHTMLCH0008_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/ch0009_part01",
 			"name" : "xhtml/ch0009_part01",
 			"component" : XHTMLCH0009_PART01
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js